// Route guards driven by the session context. RequireAuth gates the app shell;
// RedirectIfAuthed bounces logged-in users away from the auth screens.
import { Suspense } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useSession } from "../lib/session";

export function FullScreenLoader() {
  return (
    <div className="flex h-full items-center justify-center bg-canvas text-muted">
      <Loader2 className="animate-spin" size={24} strokeWidth={2} />
    </div>
  );
}

// Suspense boundary for the route-level lazy-loaded page chunks.
function LazyOutlet() {
  return (
    <Suspense fallback={<FullScreenLoader />}>
      <Outlet />
    </Suspense>
  );
}

export function RequireAuth() {
  const { me, loading } = useSession();
  if (loading) return <FullScreenLoader />;
  if (!me?.user) return <Navigate to="/login" replace />;
  return <LazyOutlet />;
}

export function RedirectIfAuthed() {
  const { me, loading } = useSession();
  if (loading) return <FullScreenLoader />;
  if (me?.user) return <Navigate to="/" replace />;
  return <LazyOutlet />;
}
